<template>

  <div 
    v-show="error || message || warning" 
    class="alert alert-dismissible mt-1" 
    v-bind="{ class: getAlertClass() }"
    v-html="error || message || warning">
    <!-- <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close">×</a> -->
  </div>

</template>

<script>

export default {
  name: "TemplateAlert",
  props: ['error', 'message', 'warning', 'custom_class'],
  components: {
  },
  methods: {
    getAlertClass(message) {
      if(this.custom_class) {
        return this.custom_class;
      }
      
      if(this.warning) {
        return 'alert-warning';
      } else if(this.error) {
        let errorMsg = this.error.toUpperCase();
        if(errorMsg.includes('NO') && errorMsg.includes('AVAILABLE')) {
          return 'alert-warning';
        } else {
          return 'alert-danger';
        }
      } else {
        return 'alert-info';
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateAlert.vue